import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

export default new Router({
  routes: [
    {
      path: '/productService',
      name: 'productService',
      component: () => import('@/views/productService')
    },
    {
      path: '/jobs',
      name: 'jobs',
      component: () => import('@/views/jobs')
    },
    {
      path: '/aboutUs',
      name: 'aboutUs',
      component: () => import('@/views/aboutUs')
    },
    {
      path: '/productInstruction',
      name: 'productInstruction',
      component: () => import('@/views/productInstruction')
    },
    {
      path: '/productTrial',
      name: 'productTrial',
      component: () => import('@/views/productTrial')
    },
    {
      path: '/',
      name: 'webIndex',
      component: () => import('@/views/web/index')
    }, {
      path: '/wechat/one',
      name: 'one',
      component: () => import('@/views/wechat/one')
    }, {
      path: '/wechat/two',
      name: 'two',
      component: () => import('@/views/wechat/two')
    }, {
      path: '/wechat/three',
      name: 'three',
      component: () => import('@/views/wechat/three')
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js